(function () {
  'use strict';

  var BRIDGE_FLAG = '__pmcWiserCartBridge';
  var FBT_ROOT_SELECTOR = '.evm-also-bought-products';
  var FBT_BUTTON_SELECTOR = '.ws_fbt_button';
  var CART_API_WAIT_MS = 2500;
  var CART_API_POLL_MS = 50;
  var CART_REFRESH_TIMEOUT_MS = 15000;
  var DRAWER_SETTLE_MS = 180;
  var DRAWER_OPEN_WAIT_MS = 1000;
  var SHIP_CALC_INIT_WAIT_MS = 2000;
  var LOADING_STATE_POLL_MS = 50;
  var LOADING_STATE_GRACE_MS = 900;
  var REPEAT_CLICK_LOCK_MAX_MS = 30000;

  if (window.wiserAddedToCart && window.wiserAddedToCart[BRIDGE_FLAG]) return;

  var actionPromise = null;
  var busyButton = null;
  var busyRoot = null;
  var busyTimer = null;
  var loadingStateTimer = null;
  var busyStartedAt = 0;
  var wiserLoadingSeen = false;
  var previousButtonAriaDisabled = null;
  var previousRootAriaBusy = null;

  function delay(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function cartUrl() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.replace(/\/?$/, '/') + 'cart';
  }

  function isCartPage() {
    try {
      var expectedPath = new URL(cartUrl(), window.location.origin).pathname;
      return window.location.pathname.replace(/\/+$/, '') === expectedPath.replace(/\/+$/, '');
    } catch (error) {
      return /\/cart\/?$/.test(window.location.pathname);
    }
  }

  function findDrawer() {
    return document.querySelector('cart-drawer#PopupModal-CartDrawer, #PopupModal-CartDrawer, cart-drawer');
  }

  function findCartOpener() {
    return document.querySelector(
      'modal-opener[data-modal="#PopupModal-CartDrawer"] a, ' +
      'a.pmc-enterprise-header__cart-link, a.header__icon--cart'
    );
  }

  function findShippingCalculator() {
    return document.querySelector(
      '#cart-drawer-footer-shipping [data-pmc-ship-calc], ' +
      '#PopupModal-CartDrawer [data-pmc-ship-calc]'
    );
  }

  async function waitForShippingCalculator() {
    for (var waited = 0; waited <= SHIP_CALC_INIT_WAIT_MS; waited += CART_API_POLL_MS) {
      var calculator = findShippingCalculator();
      if (
        calculator &&
        calculator.__pmcShipInitialized === true
      ) {
        return true;
      }

      if (waited < SHIP_CALC_INIT_WAIT_MS) await delay(CART_API_POLL_MS);
    }

    return false;
  }

  function anotherModalIsOpen(drawer) {
    var activeModal = window.ModalDialogOpened && window.ModalDialogOpened.modal;
    return Boolean(activeModal && activeModal !== drawer);
  }

  function restoreAttribute(element, name, previousValue) {
    if (!element || typeof element.setAttribute !== 'function') return;

    if (previousValue === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, previousValue);
    }
  }

  function releaseClickLock() {
    if (busyTimer !== null) {
      window.clearTimeout(busyTimer);
      busyTimer = null;
    }

    if (loadingStateTimer !== null) {
      window.clearTimeout(loadingStateTimer);
      loadingStateTimer = null;
    }

    restoreAttribute(busyButton, 'aria-disabled', previousButtonAriaDisabled);
    restoreAttribute(busyRoot, 'aria-busy', previousRootAriaBusy);

    busyButton = null;
    busyRoot = null;
    busyStartedAt = 0;
    wiserLoadingSeen = false;
    previousButtonAriaDisabled = null;
    previousRootAriaBusy = null;
  }

  function currentBusyButton() {
    if (busyRoot && typeof busyRoot.querySelector === 'function') {
      return busyRoot.querySelector(FBT_BUTTON_SELECTOR) || busyButton;
    }

    return busyButton;
  }

  function watchWiserLoadingState() {
    if (!busyButton) return;

    var currentButton = currentBusyButton();
    var isLoading = Boolean(
      currentButton &&
      currentButton.classList &&
      currentButton.classList.contains('ws-loading')
    );
    var elapsed = Date.now() - busyStartedAt;

    if (isLoading) wiserLoadingSeen = true;

    if (
      !actionPromise &&
      (
        (wiserLoadingSeen && !isLoading) ||
        (!wiserLoadingSeen && elapsed >= LOADING_STATE_GRACE_MS) ||
        elapsed >= REPEAT_CLICK_LOCK_MAX_MS
      )
    ) {
      releaseClickLock();
      return;
    }

    loadingStateTimer = window.setTimeout(
      watchWiserLoadingState,
      LOADING_STATE_POLL_MS
    );
  }

  function triggerNativeCartLoad() {
    try {
      var controller = window.lazyTemplateController;
      if (controller && typeof controller.triggerOnce === 'function') {
        controller.triggerOnce();
        return;
      }

      if (
        typeof window.dispatchEvent === 'function' &&
        typeof window.CustomEvent === 'function'
      ) {
        window.dispatchEvent(new window.CustomEvent('userFirstInteraction'));
      }
    } catch (error) {
      // The readiness poll uses the cart-page fallback if lazy loading fails.
    }
  }

  function captureFbtClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(FBT_BUTTON_SELECTOR);
    var root = button && button.closest(FBT_ROOT_SELECTOR);
    if (!button || !root) return;

    if (busyButton || actionPromise) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    busyButton = button;
    busyRoot = root;
    previousButtonAriaDisabled = button.getAttribute('aria-disabled');
    previousRootAriaBusy = root.getAttribute('aria-busy');
    busyStartedAt = Date.now();
    wiserLoadingSeen = Boolean(
      button.classList && button.classList.contains('ws-loading')
    );
    button.setAttribute('aria-disabled', 'true');
    root.setAttribute('aria-busy', 'true');
    triggerNativeCartLoad();

    busyTimer = window.setTimeout(function () {
      releaseClickLock();
    }, REPEAT_CLICK_LOCK_MAX_MS);
    loadingStateTimer = window.setTimeout(
      watchWiserLoadingState,
      LOADING_STATE_POLL_MS
    );
  }

  async function waitForNativeCart() {
    for (var waited = 0; waited <= CART_API_WAIT_MS; waited += CART_API_POLL_MS) {
      var cart = window.cartBase;
      var drawer = findDrawer();

      if (
        cart &&
        typeof cart.refreshCart === 'function' &&
        window.__pmcShipCalcBound === true &&
        drawer &&
        typeof drawer.show === 'function'
      ) {
        return { cart: cart, drawer: drawer };
      }

      if (waited < CART_API_WAIT_MS) await delay(CART_API_POLL_MS);
    }

    return null;
  }

  function withTimeout(promise, milliseconds) {
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        reject(new Error('Cart drawer refresh timed out.'));
      }, milliseconds);

      Promise.resolve(promise).then(
        function (value) {
          window.clearTimeout(timer);
          resolve(value);
        },
        function (error) {
          window.clearTimeout(timer);
          reject(error);
        }
      );
    });
  }

  async function refreshAndOpenDrawer() {
    if (isCartPage()) return true;

    triggerNativeCartLoad();
    await delay(DRAWER_SETTLE_MS);

    var nativeCart = await waitForNativeCart();
    if (!nativeCart) return false;

    if (anotherModalIsOpen(nativeCart.drawer)) return false;

    nativeCart.cart.isSectionsValidated = false;
    await withTimeout(nativeCart.cart.refreshCart(), CART_REFRESH_TIMEOUT_MS);

    if (!(await waitForShippingCalculator())) return false;

    var drawer = findDrawer();
    if (!drawer || typeof drawer.show !== 'function') return false;

    if (drawer.classList && drawer.classList.contains('is-empty')) return false;

    if (
      typeof drawer.hasAttribute !== 'function' ||
      !drawer.hasAttribute('open')
    ) {
      await Promise.resolve(drawer.show(findCartOpener()));
    }

    if (typeof drawer.hasAttribute !== 'function') return true;

    for (var waited = 0; waited <= DRAWER_OPEN_WAIT_MS; waited += CART_API_POLL_MS) {
      if (drawer.hasAttribute('open')) return true;
      if (waited < DRAWER_OPEN_WAIT_MS) await delay(CART_API_POLL_MS);
    }

    return false;
  }

  function openCartPage() {
    if (isCartPage()) return;

    var url = cartUrl();
    if (window.location && typeof window.location.assign === 'function') {
      window.location.assign(url);
    } else {
      window.location.href = url;
    }
  }

  function wiserAddedToCart() {
    if (actionPromise) return actionPromise;

    actionPromise = (async function () {
      var opened = false;

      try {
        opened = await refreshAndOpenDrawer();
      } catch (error) {
        opened = false;
      }

      if (!opened) {
        openCartPage();
      }
      return opened;
    })();

    actionPromise.then(
      function () {
        actionPromise = null;
        if (!busyButton) return;

        if (loadingStateTimer === null) {
          loadingStateTimer = window.setTimeout(
            watchWiserLoadingState,
            LOADING_STATE_POLL_MS
          );
        }
      },
      function () {
        actionPromise = null;
        releaseClickLock();
      }
    );

    return actionPromise;
  }

  wiserAddedToCart[BRIDGE_FLAG] = true;
  window.wiserAddedToCart = wiserAddedToCart;

  document.addEventListener('click', captureFbtClick, true);
})();
